import { jsx as _jsx } from "react/jsx-runtime";
const styles = {
    container: {
        height: '100%',
        backgroundColor: 'white',
    },
    label: {
        textAlign: 'center',
        width: '100%',
        fontSize: '11px',
        padding: '5px',
        color: 'gray',
    },
};
// placeholder for empty tables if no data is available to show (e.g. peaks, integrals, ranges)
function NoTableData({ text = 'No Data' }) {
    return (_jsx("div", { style: styles.container, children: _jsx("p", { style: styles.label, children: text }) }));
}
export default NoTableData;
